import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=bf43fb56&scoped=true&"
import script from "./Presence.vue?vue&type=script&lang=js&"
export * from "./Presence.vue?vue&type=script&lang=js&"
import style0 from "./Presence.vue?vue&type=style&index=0&id=bf43fb56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf43fb56",
  null
  
)

export default component.exports